// React i hooks
import { memo, useState } from "react";

// API servisi
import { deleteWarehouseAPI } from "services/api/fleet/warehouses/api";


// Tipovi i konstante
import { WarehouseDeleteProps } from "./types";

// UI komponente
import { Button } from "ui/components/Button/Button";

import { Loader } from "ui/components/Loader";
import { ReactSVG } from "react-svg";
import { useTranslate } from "helpers";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";

const WarehouseDeleteCard: React.FC<
  WarehouseDeleteProps
> = (props) => {

  const { warehouseId, show, onClose, onSuccess } = props;
  
  const { t } = useTranslate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      let result;
      if (!!warehouseId) {
        result = await deleteWarehouseAPI(warehouseId);
      }

      if (result && onSuccess) onSuccess();
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  return (
    <Modal show={show} onHide={onClose}>
      <ModalHeader icon="/media/images/remove-icon.svg" onHide={onClose} />
      <ModalBody>
        <div className="flex gap-4">
          <div className="w-full m-auto">
            <div className="space-y-3">
              <form noValidate className="text-left">
                <div className="px-5 pb-3 mb-2">
                  <div className=" focus:outline-none focus:ring-2 focus:ring-slate-400 rounded-sm py-4 flex justify-center items-center mb-3">
                    <div className="flex items-center flex-col">
                      <ReactSVG
                        src={"/media/images/document-move.svg"}
                        className="mx-auto w-fit mb-10"
                      />
                      <div className="font-medium text-sm text-[#475467] ">
                        {t(
                          "admin.fleet.warehouse.delete.description"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-5 py-3 absolute bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end ">
                  <Button
                    variant="remove"

                    children={t("admin.delete")}
                    onClick={handleFormSubmit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>

        <Loader isLoading={isLoading ?? false}> </Loader>
      </ModalBody>
    </Modal>
  );
};
export default memo(WarehouseDeleteCard);
